module.exports = __webpack_public_path__ + "img/ch-coping-strategies.367926b4.jpg";